import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import DefaultAvatarImg from '../../../assets/svg/avatar-default.svg';
import { getRoleUser } from '../../../utils';

function Contact({ user, onChangeConversation }) {
  const role = {
    name: getRoleUser(user?.role?.id),
    color: user?.role?.id === 1 ? 'primary' : 'success',
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={`msg ${!!user?.activeChat && 'active'}`}
      onClick={() => onChangeConversation(user)}>
      <img className="msg-profile" src={DefaultAvatarImg} alt="" />
      <div className="msg-detail">
        <div className="msg-username">
          {user.name} {user.last_name}
        </div>
        <div className="msg-content">
          {role && <Chip label={role.name} size="small" color={role.color} variant="outlined" />}
        </div>
      </div>
    </div>
  );
}

Contact.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.any.isRequired,
  onChangeConversation: PropTypes.func.isRequired,
};

export default Contact;
